module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "GEQB-EBNative-2.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "story"
  }, [_c('h2', {
    attrs: {
      "id": "toc_marker-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "Anchor-5"
    }
  }, [_vm._v("ABOUT THIS BOOK")])]), _c('a', {
    attrs: {
      "id": "Anchor-5"
    }
  }, [_c('p', {
    staticClass: "first"
  }, [_vm._v("The recipes in this book were selected from 25 years of the Chicago Tribune’s best food reporting. Several of the recipes were created in the Tribune test kitchen. Many of the recipes include nutrition information to aid in menu planning.")])])]), _c('a', {
    attrs: {
      "id": "Anchor-5"
    }
  })]), _c('a', {
    attrs: {
      "id": "Anchor-5"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7203fa0d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GEQBEBNative2.vue
// module id = 63
// module chunks = 0